import { PATHS, PUBLIC_INFO_PATHS } from "../../constants";

/**
 * Адрес, куда вернуть пользователя после входа. Только наш origin и только страницы
 * приложения: информационные страницы и `/login` возвратом не бывают, иначе после
 * входа пользователь снова увидит «Сессия завершена» или запустит вход по кругу.
 */
export function getSafeReturnUrl(candidate?: string | null): string {
  const { origin } = window.location;
  const fallback = `${origin}${PATHS.MAIN_PAGE}`;
  if (!candidate) {
    return fallback;
  }

  let url: URL;
  try {
    url = new URL(candidate, origin);
  } catch {
    return fallback;
  }

  const isServicePath =
    url.pathname === PATHS.LOGIN_PAGE ||
    url.pathname.startsWith(`${PATHS.LOGIN_PAGE}/`) ||
    PUBLIC_INFO_PATHS.includes(url.pathname);

  return url.origin === origin && !isServicePath ? url.href : fallback;
}

/** Путь текущей страницы — для параметра `returnUrl` информационных страниц. */
export const getCurrentRelativeUrl = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;
